export const floorToPrecision = (value: number, precision: number) => {
    // precision is an integer, so precision = 4 would mean flooring to the nearest 0.0001
    const multiple = 10 ** precision; //this should be an integer, so we avoid floating point errors
    return Math.floor(value * multiple) / multiple;
};
export const roundToPrecision = (value: number, precision: number) =>
    parseFloat(value.toFixed(precision));
